
export const SETTINGS_SAVEAS = 'saveAs'
export const SETTINGS_SAVEINTO = 'saveInto'
export const SETTINGS_CAPTURE_DEST = 'captureDest'
export const SETTINGS_OFFER_SHARE_AFTER_CAPTURE = 'offerShareAfterCapture'
export const SETTINGS_DCMHEADER = 'exportAs'
export const SETTINGS_OVERLAY = 'overlay'
export const SETTINGS_MEASUREMENT = 'measurement'
export const SETTINGS_FSVIEW = 'fsView'
export const SETTINGS_DICOMDIRVIEW = 'dicomdirView'
export const SETTINGS_MPRINTERPOLATION = 'mprInterpolation'
